export default {
  title: {
    en: "Account",
    ja: "アカウント"
  },
  contactInformation: {
    en: "Contact information",
    ja: "連絡先"
  },
  email: {
    en: "Email",
    ja: "Eメール"
  },
  phone: {
    en: "Phone",
    ja: "電話"
  },
  communicationMethod: {
    en: "Communication method",
    ja: "通信方法"
  },
  changeButton: {
    en: "Change",
    ja: "変化する"
  },
  dangerZone: {
    en: "Danger zone",
    ja: "危険区域"
  },
  changePasswordButton: {
    en: "Change password",
    ja: "パスワードを変更する"
  },
  deleteAccountButton: {
    en: "Delete account",
    ja: "アカウントを削除する"
  }
}
